import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PaymentMethod, PaymentMethods } from '@arema/components/Classes';
import SearchCoreDropdown, { SearchDropdownProps } from './SearchCoreDropdown';
import API from '../API';

var SearchPaymentMethodDropdown = (props: SearchDropdownProps)=>{
	var { t } = useTranslation();
	return <SearchCoreDropdown
		style={props.style}
		label={props.label || t('common.payment_method')}
		placeholder={props.placeholder}
		value={props.value}
		onValueChange={props.onValueChange}
		onShowLoad={async ()=>{
			var res = await API.getEventsQL(['payment_methods_all']);
			return {
				error: res.error,
				code: res.code,
				message: res.message,
				data: (
					res.data?.payment_methods_all.filter(a=>([PaymentMethods.FREE, PaymentMethods.UNKNOWN].indexOf(a.method_id)==-1))
				) as PaymentMethod[],
			};
		}}
		renderItem={a=>({
			text: a.method_name_internal,
			value: a.method_id,
			meta: `ID: ${a.method_id}`,
		})}
	/>
}

export default SearchPaymentMethodDropdown;